export const painPoints = [
  'Papeles acumulados durante años sin un orden claro, mezclados con estudios digitales y físicos.',
  'No sabés dónde encontrar un informe justo cuando te lo piden.',
  'La historia del tratamiento está fragmentada y vive solo en tu cabeza.',
  'Sensación constante de "me falta algo importante" y ansiedad cada vez que llega un nuevo documento.'
];

export const costs = [
  ['Decisiones a ciegas', 'El riesgo de que el neurólogo decida el tratamiento sin ver los estudios que no encontrás.'],
  ['Angustia del papel perdido', 'Saber que hay un dato vital enterrado en un sobre que hoy no aparece.'],
  ['Carga mental extrema', 'El peso de llevar 10 años de historia solo en tu memoria. Si fallás, la historia se pierde.']
] as const;

export const faqs = [
  ['¿Necesito saber de medicina o administración?', 'No. Solo reunís, clasificás y registrás. El médico interpreta.'],
  ['¿Cuánto tiempo me toma cada día?', '20 a 45 minutos diarios. Es posible hacer versiones mínimas en 10 minutos.'],
  ['¿Qué pasa si no termino en 7 días?', 'El método sigue siendo válido. 7 días es el tiempo recomendado, pero podés ir más lento.'],
  ['¿Es totalmente digital?', 'Sí. Acceso inmediato en PDF desde celular, tablet o computadora. Podés imprimirlo si lo preferís.'],
  ['¿Cómo me llega?', 'Por email en minutos con enlace de descarga. Podés leerlo en cualquier dispositivo.']
] as const;

export const stats = [
  ['+380', 'madres usando el sistema'],
  ['3', 'Volúmenes completos'],
  ['5', 'Bonos incluidos'],
  ['4.9/5', 'calificación']
] as const;
